import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = ["disabled"]

import { computed, watch, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useStrategyFixPageQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { useTriggerMetricUpdatesCommandV1 } from '@Quest/Strategies/commands-vue-composables'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyFixPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const workspaceId = computed(() => Number(route.params.workspaceId))
    const strategyId = computed(() => String(route.params.strategyId))

    const {
        runStrategyFixPageQueryV1,
        modelStrategyFixPageQueryV1: rm
    } = useStrategyFixPageQueryV1(workspaceId, strategyId)

    const {
        invokeTriggerMetricUpdatesCommandV1,
        invokingTriggerMetricUpdatesCommandV1,
        errorTriggerMetricUpdatesCommandV1,
        succeedTriggerMetricUpdatesCommandV1
    } = useTriggerMetricUpdatesCommandV1(workspaceId, strategyId);


    onMounted(() =>
    {
        document.title = "Enterprise Fix | TransparentChoice";
        runStrategyFixPageQueryV1();
    })


    watch(errorTriggerMetricUpdatesCommandV1, (err) =>
    {
        if (err)
        {
            alert(err)
        }
    })

    watch(succeedTriggerMetricUpdatesCommandV1, (succeeded) =>
    {
        alert('Done');
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "alert alert-danger",
            role: "alert"
          }, [
            _createElementVNode("h4", { class: "alert-heading" }, "Warning: Advanced Operations Ahead"),
            _createElementVNode("p", null, [
              _createTextVNode(" This page provides access to advanced troubleshooting commands that can significantly impact customer data and system functionality. "),
              _createElementVNode("strong", null, "If you are unsure about a command, do not proceed."),
              _createTextVNode(" Consult the documentation or seek guidance before making changes. ")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "card-title" }, "Update Metrics", -1 /* CACHED */)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-text" }, [
                    _createTextVNode(" Metric updates are automatically triggered by the system when data changes. "),
                    _createElementVNode("strong", null, "Use this only if you suspect an issue due to a bug.")
                  ], -1 /* CACHED */)),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "card-text" }, [
                    _createTextVNode(" Triggering a metric update requires updating all enterprise projects. "),
                    _createElementVNode("strong", null, "Avoid running this command during peak hours"),
                    _createTextVNode(" to reduce the risk of disrupting active users. ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-block",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(invokeTriggerMetricUpdatesCommandV1) && _unref(invokeTriggerMetricUpdatesCommandV1)(...args))),
                    disabled: _unref(invokingTriggerMetricUpdatesCommandV1)
                  }, " Trigger Metrics Update ", 8 /* PROPS */, _hoisted_6)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})